import { propOr } from 'ramda';

export const playerHistorySelector = propOr({}, 'history');
